/**
 * Portal API Client
 * Separate from the main app's Auth0-based API client.
 * Uses JWT email/password authentication for developer portal.
 */

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';
const PORTAL_BASE = `${API_BASE}/developers`;

class PortalApiClient {
  constructor() {
    this.token = localStorage.getItem('portal_token');
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('portal_token', token);
    } else {
      localStorage.removeItem('portal_token');
    }
  }

  getToken() {
    return this.token;
  }

  async request(path, options = {}) {
    const url = path.startsWith('http') ? path : `${PORTAL_BASE}${path}`;
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers,
      signal: options.signal,
    });

    if (!response.ok) {
      const data = await response.json().catch(() => null);
      const error = new Error(data?.detail || data?.error?.message || `Request failed: ${response.status}`);
      error.status = response.status;
      error.data = data;
      throw error;
    }

    if (response.status === 204) return null;
    return response.json();
  }

  get(path, options = {}) {
    return this.request(path, { method: 'GET', ...options });
  }

  post(path, body, options = {}) {
    return this.request(path, { method: 'POST', body: JSON.stringify(body), ...options });
  }

  patch(path, body, options = {}) {
    return this.request(path, { method: 'PATCH', body: JSON.stringify(body), ...options });
  }

  put(path, body, options = {}) {
    return this.request(path, { method: 'PUT', body: JSON.stringify(body), ...options });
  }

  delete(path, options = {}) {
    return this.request(path, { method: 'DELETE', ...options });
  }
}

export const portalApi = new PortalApiClient();
export default portalApi;
